/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();










(function () {
  const DURATION_DAYS = 10;
  const DURATION_MS = DURATION_DAYS * 24 * 60 * 60 * 1000;
  const storageKey = 'a_derma_countdown_start';

  function getEndTime() {
    let startTime = localStorage.getItem(storageKey);
    if (!startTime) {
      startTime = Date.now();
      localStorage.setItem(storageKey, startTime);
    } else {
      startTime = parseInt(startTime, 10);
    }
    return startTime + DURATION_MS;
  }

  const endTime = getEndTime();

  function injectCountdown() {
    // uniquement sur A-Derma (ajuste si besoin)
    if (!location.pathname.includes('/a-derma')) return;

    document.querySelectorAll('block-price').forEach(block => {
      const container = block.querySelector('.block-price__container');
      if (!container) return;

      // éviter doublons
      if (container.querySelector('.price-countdown-inline')) return;

      const el = document.createElement('span');
      el.className = 'price-countdown-inline';
      el.innerHTML = ` | <span class="countdown-timer"></span>`;
      container.appendChild(el);

      const timer = el.querySelector('.countdown-timer');

      function update() {
        let diff = endTime - Date.now();
        if (diff <= 0) {
          el.remove();
          return;
        }

        const d = Math.floor(diff / 86400000);
        diff %= 86400000;
        const h = Math.floor(diff / 3600000);
        diff %= 3600000;
        const m = Math.floor(diff / 60000);
        const s = Math.floor((diff % 60000) / 1000);

        timer.textContent = `${d}d ${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
      }

      update();
      el._interval = setInterval(update, 1000);
    });
  }

  // 1) Injection initiale
  document.addEventListener('page:loaded', injectCountdown);

  // 2) OBSERVER — réinjecte si Expanse remodifie le DOM
  const observer = new MutationObserver(injectCountdown);
  observer.observe(document.body, { childList: true, subtree: true });
})();